<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>
        {{ saleInfo.saleName }}<br />
        <span class="text-muted">#Sales: {{ saleInfo.code }} </span>
      </h1>
      <div class="btn-group float-right sm-float-none">
        <button class="f12 font-medium btn btn-outline-secondary" @click="backToList()">
          Quay lại
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              placeholder="Thời gian"
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label style="min-width: 13.5em" class="text-center pt-1">
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model="search.textSearch"
              class="form-control f12 hc-37"
              placeholder="Từ khóa"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="search.mcc" :options="dataConfigMcc" placeholder="Ngành hàng" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.advanceState" :options="dataState" placeholder="Trạng thái" />
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              @click="clearSearch"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Bỏ lọc
            </button>
            <button
              @click="exportExcel"
              v-if="dataPermission.includes('CNPS_CSTM_MERCHANT_LIST_XLS')"
              type="button"
              class="btn btn-info hc-37 mr-2 pt-2 file-input"
              data-toggle="tooltip"
              data-placement="top"
              title="Xuất Excel"
            >
              <i class="bx bx-download"></i>
              <span class="ml-1">&nbsp;</span>Xuất Excel
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="table-responsive">
            <div class="box-header mb-1">
              Tổng số Merchant:<strong class="text-primary">{{ statistical.totalMc }}</strong
              >&nbsp;&nbsp;| &nbsp;&nbsp; Đã giải ngân :<strong class="text-primary">{{
                statistical.totalDisbursed
              }}</strong>
              &nbsp;&nbsp;| &nbsp;&nbsp; Đã duyệt :<strong class="text-primary">{{
                statistical.totalActived
              }}</strong>
              &nbsp;&nbsp;| &nbsp;&nbsp; Chờ duyệt :<strong class="text-primary">{{
                statistical.totalNew
              }}</strong>
              &nbsp;&nbsp;| &nbsp;&nbsp; Đang tiếp cận :<strong class="text-primary">{{
                statistical.totalDraft
              }}</strong>
              &nbsp;&nbsp;| &nbsp;&nbsp; Từ chối HS :<strong class="text-primary">{{
                statistical.totalRejected
              }}</strong
              >&nbsp;&nbsp;| &nbsp;&nbsp; Số tiền ứng :<strong class="text-primary">{{
                statistical.totalLentAmount | fomatCurrency
              }}</strong>
              &nbsp;&nbsp;| &nbsp;&nbsp; Hồ sơ sai :<strong class="text-primary">{{
                statistical.totalInvalidProfile
              }}</strong>
            </div>
            <table class="table table-hover table-bordered" id="tableScroll">
              <thead class="thead-light">
                <tr>
                  <th scope="col">STT</th>
                  <th scope="col">Thời gian tạo</th>
                  <th scope="col">Merchant</th>
                  <th scope="col">Địa chỉ</th>
                  <th scope="col">Tỉnh/Thành phố</th>
                  <th scope="col">Ngành hàng</th>
                  <th scope="col">Tiền ứng</th>
                  <th scope="col">Trạng thái</th>
                </tr>
              </thead>
              <tbody v-if="loading">
                <tr>
                  <td colspan="11" align="center">
                    <i class="bx bx-loader-circle bx-spin bx-rotate-90 f30"></i>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr class="table-row" v-for="(item, index) in dataMC" :key="index">
                  <td class="text-center">
                    {{ index + 1 }}
                  </td>
                  <td>
                    {{ item.nextLendLentCreatedDate }}
                  </td>
                  <td>
                    {{ item.merchantName }} <br />
                    <a href="#">{{ item.mobile }}</a>
                  </td>
                  <td>
                    {{ item.address }}
                  </td>
                  <td>
                    {{ item.city }}
                  </td>
                  <td>
                    {{ item.mcc | transfromMccName(dataConfigMcc) }}
                  </td>
                  <td>
                    {{ item.nextLendLentAmount | fomatCurrency }}
                  </td>
                  <td>
                    <span v-if="item.advanceState === 'NEW'" class="badge badge-warning"
                      >Chờ duyệt</span
                    >
                    <span v-if="item.advanceState === 'ACTIVED'" class="badge badge-success"
                      >Đã duyệt</span
                    >
                    <span v-if="item.advanceState === 'REJECTED'" class="badge badge-danger"
                      >Từ chối hồ sơ</span
                    >
                    <span v-if="item.advanceState === 'DISBURSED'" class="badge badge-success"
                      >Đã giải ngân</span
                    >
                    <span v-if="item.advanceState === 'INVALID_PROFILE'" class="badge badge-danger"
                      >Hồ sơ sai</span
                    >
                    <span v-if="item.advanceState === 'DRAFT_CONTRACT'" class="badge badge-info"
                      >Đang tiếp cận</span
                    >
                    <span v-if="item.advanceState === 'POTENTIAL'" class="badge badge-danger"
                      >Tiềm năng</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination-bottom">
      <b-pagination
        v-model="search.page"
        :total-rows="pagination.total"
        :per-page="search.limit"
        class="fl-right mr-2"
      ></b-pagination>
    </div>
  </div>
</template>
<script>
  import { MerchantService } from '@/services/merchant.service'
  import { CommonService } from '@/services/common.service'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import { mapGetters } from 'vuex'
  // import Config from '../../thirdParty/config'
  import moment from 'moment'
  export default {
    components: {},
    filters: {
      // lấy giờ tạo
      // formatHour (date) {
      //   return date.substring(10, 16)
      // },
      // // lấy ngày tạo
      // formatDate (date) {
      //   return date.substring(0, 10)
      // },
      transfromMccName(data, dataConfigMcc) {
        const dataReturn = dataConfigMcc.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
      // lấy ngày, giờ
      // formatTime (ms) {
      //   return new Date(ms).getHours() + ':' + new Date(ms).getMinutes() + ', ' +
      //   new Date(ms).getDate() + '/' + (new Date(ms).getMonth() + 1) + '/' + new Date(ms).getFullYear()
      // },
      formatDatePicker(date) {
        if (!date) return
        return moment(date).format('DD/MM/YYYY')
      },
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    data() {
      return {
        loading: true,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataMC: [],
        localeData: {
          direction: 'ltr',
          format: 'dd/mm/yyyy',
          separator: ' - ',
          applyLabel: 'Áp dụng',
          cancelLabel: 'Hủy bỏ',
          weekLabel: 'W',
          daysOfWeek: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
          monthNames: [
            'Tháng 1',
            'Tháng 2',
            'Tháng 3',
            'Tháng 4',
            'Tháng 5',
            'Tháng 6',
            'Tháng 7',
            'Tháng 8',
            'Tháng 9',
            'Tháng 10',
            'Tháng 11',
            'Tháng 12',
          ],
          firstDay: 0,
        },
        dateRange: {
          startDate: null,
          endDate: null,
        },
        search: {
          limit: 50,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        dataState: [
          { text: 'Chờ duyệt', id: 'NEW' },
          { text: 'Đã duyệt', id: 'ACTIVED' },
          { text: 'Từ chối hồ sơ', id: 'REJECTED' },
          { text: 'Đã giải ngân', id: 'DISBURSED' },
          { text: 'Sai hồ sơ', id: 'INVALID_PROFILE' },
          { text: 'Đang tiếp cận', id: 'DRAFT_CONTRACT' },
          { text: 'Tiềm năng', id: 'POTENTIAL' },
        ],
        statistical: {},
        saleInfo: {},
        dataConfigMcc: [],
      }
    },
    mounted() {
      this.fetchData('1')
      this.configSystem()
    },
    watch: {
      'search.limit': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    methods: {
      // quay lại trang merchant nextlend
      backToList() {
        this.$router.push({ path: '/list-mc-nextlend' })
      },
      // nút lọc
      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        this.fetchData()
      },
      // nút bỏ lọc
      async clearSearch() {
        this.search = {
          limit: 50,
          page: 1,
        }
        await this.fetchData('2')
      },
      // xuất Excel
      async exportExcel() {
        try {
          this.loading = true
          await MerchantService.exportMerchantNextlendDetail(this.search)
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      // define ngày trên lịch
      transformDate() {
        this.search.startDate = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.endDate = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
      // lấy ngành hàng và dịch vụ
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              data.data.businessFields.map(e =>
                this.dataConfigMcc.push({ id: e.code, text: e.name })
              )
            }
          })
          .catch(error => console.log(error))
      },
      // dữ liệu bảng
      async fetchData(key) {
        this.loading = true
        try {
          // this.search.userId = this.dataUser.userId
          if (key === '1') {
            this.dateRange = {
              startDate: JSON.parse(localStorage.getItem('startDate')),
              endDate: JSON.parse(localStorage.getItem('endDate')),
            }
          }
          if (key === '2') {
            this.dateRange = {
              startDate: null,
              endDate: null,
            }
          }
          this.transformDate()
          this.search.saleEmail = this.$route.params.activeSaleEmail
          const data = await MerchantService.nextlendMCReportDetail(this.search)
          if (data.success) {
            this.dataMC = data.data.rows
            this.pagination.total = data.meta.pagination.total ? data.meta.pagination.total : 0
            this.saleInfo = {
              saleName: data.data.rows[0].activeSaleName,
              code: data.data.rows[0].companyCode,
            }
            this.statistical = {
              totalMc: data.data.totalMc,
              totalNew: data.data.totalNew,
              totalActived: data.data.totalActived,
              totalRejected: data.data.totalRejected,
              totalDraft: data.data.totalDraft,
              totalInvalidProfile: data.data.totalInvalidProfile,
              totalLentAmount: data.data.totalLentAmount,
              totalDisbursed: data.data.totalDisbursed,
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>
